
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.60864 4.86364H18L16.7018 11.3468C16.556 12.0811 15.9048 12.6053 15.1564 12.5909H6.98864C6.20778 12.5975 5.54467 12.0206 5.44318 11.2464L4.26864 2.34455C4.16789 1.57614 3.51361 1.00117 2.73864 1H1M6.40909 18C7.26262 18 7.95455 17.3081 7.95455 16.4545C7.95455 15.601 7.26262 14.9091 6.40909 14.9091C5.55556 14.9091 4.86364 15.601 4.86364 16.4545C4.86364 17.3081 5.55556 18 6.40909 18ZM15.6818 18C16.5353 18 17.2273 17.3081 17.2273 16.4545C17.2273 15.601 16.5353 14.9091 15.6818 14.9091C14.8283 14.9091 14.1364 15.601 14.1364 16.4545C14.1364 17.3081 14.8283 18 15.6818 18Z","stroke":"#357D67","stroke-width":"1.36364","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    